package com.exura.features.plandefinition.domain.model.element


/**
 * Types of elements that can be generated from series.
 * These correspond directly to the navigation element types.
 */
enum class ElementType {
    INSTRUCTION,
    PERSISTENT,
    QUESTION,
    FLOATING
}
